/** CIM Test Data
 *
 */
import { IProfileTemplateData } from 'templates'

import {
  clientDemographicsModuleTestData,
  clientExpereienceModuleTestData,
  dataRoomModuleTestData,
  financialSnapshotModuleTestData,
  companyDetailsModuleTestData,
  keyRatiosAndMetricsModuleTestData,
  riskFactorModuleTestData,
  teamMemberModuleTestData,
  topMatchesModuleTestData,
  topPrioritiesModuleTestData
} from '@fixtures/modules'

export const CIMPageFixture = {
  companyName: 'Business Name',
  modules: [
    companyDetailsModuleTestData,
    topPrioritiesModuleTestData,
    teamMemberModuleTestData,
    clientExpereienceModuleTestData,
    keyRatiosAndMetricsModuleTestData,
    clientDemographicsModuleTestData,
    financialSnapshotModuleTestData,
    riskFactorModuleTestData,
    topMatchesModuleTestData,
    dataRoomModuleTestData
  ]
} as IProfileTemplateData
